import { Api } from 'utils';

class SurveyService {
		
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/surveys',params),
		create: async (params?: any) => Api.createResponse('admin/surveys/create',params),
		view: async (params?: any) => Api.createResponse('admin/surveys/view',params),
		update: async (params?: any) => Api.createResponse('admin/surveys/update',params),
		delete: async (params?: any) => Api.createResponse('admin/surveys/delete',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/surveys/change-status',params),
	}

}

export default SurveyService;